import React, { Fragment, useRef, useState } from "react";
import "./Toggle.css";
import {getAuthorization} from "../../../axios/AxiosAut";
import { Formik, Form, Field } from "formik";
import Swal from "sweetalert2";
import "animate.css";
import * as Yup from "yup";
import GoodsToggle from "./GoodsToggle";
import { useNavigate } from "react-router-dom";
import Incoming from "./Incoming";
import Outgoing from "./Outgoing";

function GoodsDashboard() {
  const [Toggle, setToggle] = useState("Incoming");
  const Navigate = useNavigate();

  const toggleHandler = () => {
    if (Toggle == "Outgoing") {
      setToggle("Incoming");
    } else {
      setToggle("Outgoing");
    }
  };
  const AddCustomerHandler = () => {
    Navigate("/dashboard/management/customer-dashboard/add-customer");
  };

  return (
    <>
     <div className="flex flex-col container max-w-5xl mt-2 mb-5 xl:max-w-7xl">
        <div className="flex flex-row justify-between w-full items-center">
          <div className="flex flex-row items-center">
            <div>
              {Toggle == "Incoming" ? (
                <>
                  {" "}
                  <h2 className="font-Montserrat text-xl font-bold text-black">
                    Goods In/Out
                  </h2>
                  <div className="border-b-2 border-blue-200 w-24"></div>
                </>
              ) : (
                <>
                  {" "}
                  <h2 className="font-Montserrat text-xl font-bold text-black">
                  Goods In/Out
                  </h2>
                  <div className="border-b-2 border-blue-200 w-24"></div>
                </>
              )}
            </div>
          </div>
          
        </div>
        <GoodsToggle ToggleHandler={toggleHandler} Toggle={Toggle} />
      </div>
      <div className="flex flex-col max-w-4xl mt-2 mb-5  xl:max-w-7xl">
       {Toggle == "Incoming" ?<Incoming/> : <Outgoing />}
       </div>
    </>
  );
}

export default GoodsDashboard;
